import apiClient from './apiClient';

const authAPI = {
  login: (credentials) => apiClient.post('/login', credentials),
  logout: () => apiClient.post('/logout'),
  verifyOTP: (otpData) => apiClient.post('/verify-otp', otpData),
  resendOTP: (email) => apiClient.post('/resend-otp', { email }),
  resetPassword: (resetData) => apiClient.post('/reset-password', resetData),
  forgotPassword: (email) => apiClient.post('/forgot-password', { email }),
  updateUserProfile: (updatedData) => apiClient.post('/update-profile', updatedData),
};

export default authAPI;
